import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';

// Extend plugins
dayjs.extend(utc);
dayjs.extend(timezone);

// Timezone constant
const PST_TIMEZONE = 'America/Los_Angeles';

// ✅ Reusable function
export const getCurrentPSTTime = (formatStr: string = 'YYYY-MM-DDTHH:mm:ss') => {
  return dayjs().tz(PST_TIMEZONE).format(formatStr);
};
